import { useTranslation } from 'react-i18next'
import Notice from '@ui-components-3/ui/lib/components/Notice'

type VisitConfirmationLocationProps = {
  displayLocation?: string
}

const VisitConfirmationLocation = ({ displayLocation }: VisitConfirmationLocationProps) => {
  const { t } = useTranslation()

  if (!displayLocation) {
    return null
  }

  return (
    <>
      <div className="mb-4">
        <p className="typography-body-l mb-1 font-semibold text-neutral-800">
          {t('visitCreation.confirmation.location.title')}
        </p>
        <p className="typography-body-l text-neutral-800">{displayLocation}</p>
      </div>
      <Notice variant="warning" className="mb-4">
        <p className="typography-body-l text-neutral-800">{t('visitCreation.confirmation.location.warning')}</p>
      </Notice>
    </>
  )
}

export default VisitConfirmationLocation
